<template>
  <div>

    <b-form @submit.prevent="onHandleStoreDetail()" data-vv-scope="detailsNuGreForm">

      <b-form-group v-if="useSelectNuGreInFrom" label="Seleccionar guía de respuestas a emergencias:"
        label-for="slq_emergency_response_guide_id">

        <el-select v-model="currentDetailsNuGre.slq_emergency_response_guide_id" id="slq_emergency_response_guide_id"
          name="slq_emergency_response_guide_id" filterable remote clearable no-data-text="No hay datos que coincidan"
          v-validate="'required'" data-vv-as=" " no-match-text="No hay datos que coincidan"
          :remote-method="searchEmergenciesResponseGuides">
          <el-option v-for="emergencyResponseGuide in emergencyResponseGuides" :key="emergencyResponseGuide.id"
            :label="`Código NU: ${emergencyResponseGuide.codigo_un} - Gre: ${emergencyResponseGuide.gre}, ${emergencyResponseGuide.peligro_un}`"
            :value="emergencyResponseGuide.id" />
        </el-select>

        <span class="text-danger small" v-text="errors.first('detailsNuGreForm.slq_emergency_response_guide_id')" />
        <div class="alert alert-info text-small mt-1 p-2">Puedes buscar la guía por su propiedades: Código naciones unidas, Gre o Nombre del material.</div>
      </b-form-group>

      <b-form-group label="Seleccionar el campo:" label-for="slq_custom_field_nu_gre_id">
        <Treeselect :value="value" name="slq_custom_field_nu_gre_id" id="slq_custom_field_nu_gre_id" clearable
          :options="getCustomFields()" :normalizer="normalizerSelectTree" placeholder="Seleccionar"
          :flatten-search-results="true" v-validate="'required'" data-vv-as=" " :disable-branch-nodes="true"
          v-model="currentDetailsNuGre.slq_custom_field_nu_gre_id" :defaultExpandLevel="Infinity"
          no-results-text="No se encontraron resultados." :max-height="300" class="custom-treeselect"
          value-consists-of="ALL" noOptionsText="No hay resultados para mostrar">
        </Treeselect>

        <span class="text-danger small" v-text="errors.first('detailsNuGreForm.slq_custom_field_nu_gre_id')" />
        <span
          v-if="isInactiveCustomField"
          class="text-danger small">
            El campo personalizado [{{ currentDetailsNuGre.custom_field_nu_gre.label }}] no esta disponible.
        </span>
      </b-form-group>

      <b-form-group id="description-group" label="Ingrese una descripción" label-for="description">
        <b-form-input id="description" name="description" v-validate="'required|max:1|max:255'" data-vv-as=" " type="text"
          placeholder="Ingrese una descripción" v-model="currentDetailsNuGre.description"></b-form-input>
        <span class="text-danger small" v-text="errors.first('detailsNuGreForm.description')" />
      </b-form-group>

      <div class="d-flex justify-content-end align-items-center mt-4">
        <b-button type="submit" variant="primary">{{ action === 'CREATE' ? 'Agregar campo' : 'Guardar cambios'
        }}</b-button>
        <b-button class="ml-2" type="reset" @click="onHandleCancel()">Cancelar</b-button>
      </div>

    </b-form>
  </div>
</template>

<script>

// Importaciones generales
import { mapState, mapActions, mapMutations } from "vuex";

// Componentes
import Treeselect from "@riophae/vue-treeselect";

// Estilos adicionales
import "@riophae/vue-treeselect/dist/vue-treeselect.min.css";

export default {
  name: "ConfigNuGreFormComponent",
  data() {
    return {
      value: null
    };
  },
  components: {
    Treeselect
  },
  computed: {
    // Estados para el modulo del Naciones unidas - gre
    ...mapState('NuGreCustomFields', [
      'customFields'
    ]),
    // Estados para el modulo del Naciones unidas - gre
    ...mapState("NuGreAdmin", [
      'emergencyResponseGuides',
      'action',
      'currentDetailsNuGre',
      'currentNuGreActive',
      'useSelectNuGreInFrom'
    ]),
    // Verificar el campo personalizado esta inactivo
    isInactiveCustomField() {

      if (this.currentDetailsNuGre.custom_field_nu_gre && typeof this.currentDetailsNuGre.custom_field_nu_gre === 'object') {
        if (!this.currentDetailsNuGre.custom_field_nu_gre.is_active) {

          this.setCurrentDetailsNuGre({
            ...this.currentDetailsNuGre,
            slq_custom_field_nu_gre_id: null
          });
          return true;
        }

        return false;
      }

      return false;
    }
  },
  methods: {
    // Acciones para el modulo del Naciones unidas - gre administración
    ...mapActions("NuGreAdmin", {
      searchEmergenciesResponseGuides: 'search',
      storeDetailsToResponseEmergency: 'store',
      updateDetailsToResponseEmergency: 'update'
    }),
    // Mutaciones para el modulo del Naciones unidas - gre
    ...mapMutations('NuGreAdmin', [
      'resetDetailsNuGres',
      'setAction',
      'setCurrentDetailsNuGre'
    ]),
    /**
     * Propiedades y métodos para el selector.
     * @author Fernando Claros
     */
    getCustomFields() {
      return this.customFields.itemInTree
    },
    /**
     *  Propiedades y métodos para el selector.
     * @author Fernando Claros
     */
    normalizerSelectTree(node) {
      return {
        children: node.children && node.children.length ? node.children : 0,
      };
    },
    /**
     * Crear campos personalizados.
     * @author Fernando Claros
     */
    async onHandleStoreDetail() {
      this.$validator.validateAll('detailsNuGreForm')
        .then((result) => {
          if (result) {

            const payload = {
              id: this.currentDetailsNuGre.id,
              description: this.currentDetailsNuGre.description,
              slq_emergency_response_guide_id: this.useSelectNuGreInFrom ? this.currentDetailsNuGre.slq_emergency_response_guide_id : this.currentNuGreActive,
              slq_custom_field_nu_gre_id: this.currentDetailsNuGre.slq_custom_field_nu_gre_id
            };

            if (this.action === 'CREATE') this.storeDetailsToResponseEmergency(payload).then(() => this.onHandleCancel())
            else this.updateDetailsToResponseEmergency(payload).then(() => this.onHandleCancel())
          }
        });
    },
    /**
     * Cancelar acciones.
     * @author Fernando Claros
     */
    onHandleCancel() {
      this.resetDetailsNuGres();
      this.setAction('CREATE');
      this.$bvModal.hide('bv-modal-manage-config-nu-gres');
    },
  }
};
</script>

<style scoped>
.vue-treeselect__menu-container {
  font-weight: 200 !important;
}</style>
